module.exports = __webpack_public_path__ + "static/media/peugeot-partner.d1e6d9ac.jpg";